import { render } from "./AdminQueries.vue?vue&type=template&id=2e9114b5"
import script from "./AdminQueries.vue?vue&type=script&lang=js"
export * from "./AdminQueries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__